import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { customerContact } from 'actions'
import { title } from 'styles/texts'

import { Form, Field, Label, Input, Textarea } from 'components/form'
import ButtonComponent from 'components/Button'

const Wrapper = styled.div`
  padding: 10%;
`

const Text = styled.div`
  ${title};
  margin: 11px 0;
`

const Button = styled(ButtonComponent)`
  margin: 10px auto;
`

class ContactForm extends React.Component {
  state = {
    name: '',
    company: '',
    email: '',
    message: '',
  }

  submit = e => {
    e.preventDefault()
    this.props.customerContact(this.state)
    this.setState({ done: true })
  }

  render() {
    return this.state.done ? (
      <Wrapper>
        <Text>
          For å sikre at all informasjon er riktig og at profilene blir presise,
          har vi valgt å godkjenne alle nye brukere manuelt.
        </Text>
        <Text>
          Vi godkjenner din forspørsel så fort vi kan, og sender deg en e-post
          når vi er klare.
          <span role="img" aria-label="">
            👋
          </span>
        </Text>
        <Button secondary onClick={this.props.closeModal}>
          Snakkes snart!
        </Button>
      </Wrapper>
    ) : (
      <Form onSubmit={this.submit}>
        <Field>
          <Label htmlFor="name">Navn</Label>
          <Input
            autoFocus
            id="name"
            type="text"
            value={this.state.name}
            onChange={e => this.setState({ name: e.target.value })}
          />
        </Field>
        <Field>
          <Label htmlFor="company">Selskap</Label>
          <Input
            id="company"
            type="text"
            value={this.state.company}
            onChange={e => this.setState({ company: e.target.value })}
          />
        </Field>
        <Field>
          <Label htmlFor="email">E-post</Label>
          <Input
            id="email"
            type="text"
            value={this.state.email}
            onChange={e => this.setState({ email: e.target.value })}
          />
        </Field>
        <Field>
          <Label htmlFor="message">Fortell om ditt behov</Label>
          <Textarea
            id="text"
            type="message"
            value={this.state.message}
            onChange={e => this.setState({ message: e.target.value })}
          />
        </Field>
        <Button type="submit">Send</Button>
      </Form>
    )
  }
}

const mapStateToProps = () => ({})

const mapDispatchToProps = { customerContact }

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm)



// WEBPACK FOOTER //
// ./src/components/Header/CustomerContactForm.js